import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const lastPathname = useRef(pathname);

  useEffect(() => {
    const handleScroll = () => {
      sessionStorage.setItem(`scroll-${pathname}`, window.pageYOffset.toString());
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    const savedPosition = sessionStorage.getItem(`scroll-${pathname}`);
    
    if (pathname.startsWith('/news/')) {
      window.scrollTo(0, 0);
    } else if (savedPosition && pathname === lastPathname.current) {
      window.scrollTo(0, parseInt(savedPosition));
    } else if (savedPosition && lastPathname.current.startsWith('/news/') && pathname === '/news') {
      setTimeout(() => {
        window.scrollTo(0, parseInt(savedPosition));
      }, 50);
    } else {
      window.scrollTo(0, 0);
    }

    lastPathname.current = pathname;

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [pathname]);

  return null;
};

export default ScrollToTop;
